const TYPE_CD = {
  SEEDING: 1,
  RENTAL: 2
}

const STATUS_FL_CD = {
  REG          : 1,
  REG_COMPLETE : 2,
  INCOME       : 3,
  RENT_ING     : 4,
  RETURN_REQ   : 5,
  ACCEPT_RETURN: 6,
  RETURN_ING   : 7,
  RETURNED     : 8,
  SEASON_OUT   : 9
}

const PRODUCT = {
  TYPE_CD,
  STATUS_FL_CD,
}

export default PRODUCT
